import { useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { apiGetTGLink } from "./service";

export const useGetTGLink = ({ options }) => {
  return useQuery(
    [queryKey.TG_LINK],
    () =>
      apiGetTGLink({}).then((res) => {
        return res.data;
      }),
    {
      staleTime: 10 * (60 * 1000), //10mins
      cacheTime: 10 * (60 * 1000), //10mins
      ...options,
    },
  );
};
